const breakpoints = {
    xxs: 320,
    xs: 450,
    sm: 680,
    md: 768,
    lg: 992,
    xl: 1170,
    xxl: 1440,
    xxxl: 1920,
    super: 2400,
}

const mediaQueries = {
    'xxs': window.matchMedia(`(min-width: ${breakpoints.xxs}px)`),
    'xs': window.matchMedia(`(min-width: ${breakpoints.xs}px)`),
    'sm': window.matchMedia(`(min-width: ${breakpoints.sm}px)`),
    'md': window.matchMedia(`(min-width: ${breakpoints.md}px)`),
    'lg': window.matchMedia(`(min-width: ${breakpoints.lg}px)`),
    'xl': window.matchMedia(`(min-width: ${breakpoints.xl}px)`),
    'xxl': window.matchMedia(`(min-width: ${breakpoints.xxl}px)`),
    'xxxl': window.matchMedia(`(min-width: ${breakpoints.xxxl}px)`),
    'super': window.matchMedia(`(min-width: ${breakpoints.super}px)`),
    'xxs-max': window.matchMedia(`(max-width: ${breakpoints.xxs - 1}px)`),
    'xs-max': window.matchMedia(`(max-width: ${breakpoints.xs - 1}px)`),
    'sm-max': window.matchMedia(`(max-width: ${breakpoints.sm - 1}px)`),
    'md-max': window.matchMedia(`(max-width: ${breakpoints.md - 1}px)`),
    'lg-max': window.matchMedia(`(max-width: ${breakpoints.lg - 1}px)`),
    'xl-max': window.matchMedia(`(max-width: ${breakpoints.xl - 1}px)`),
    'xxl-max': window.matchMedia(`(max-width: ${breakpoints.xxl - 1}px)`),
    'xxxl-max': window.matchMedia(`(max-width: ${breakpoints.xxxl - 1}px)`),
    'super-max': window.matchMedia(`(max-width: ${breakpoints.super - 1}px)`),
}

const checkMediaQueryMatches = (size) => {
    return mediaQueries[size].matches;
}

const handlers = [];

const callMediaQueryHandlers = (handlers, mediaQuery, event) => {
    handlers.forEach(handler => handler(event, mediaQuery));
}

const registerHandler = (handler) => handlers.push(handler);

const init = () => {
    for (const mq in mediaQueries) {
        if (mediaQueries.hasOwnProperty(mq)) {
            let mediaQuery = mediaQueries[mq];

            callMediaQueryHandlers(handlers, mediaQuery);
            
            mediaQuery.addEventListener('change', (e) => {
                callMediaQueryHandlers(handlers, mediaQuery, e)
            });
        }
    }
}

export { init as default, breakpoints, mediaQueries, checkMediaQueryMatches, registerHandler }
